import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Loader from 'react-loader-spinner';

import * as COMPANIES_SELECTORS from '../../../store/selectors/companies';
import * as SUBSCRIPTIONS_SELECTOR from '../../../store/selectors/subscriptions';

import { LOCALE_NAMESPACE } from '../../../const/translations/LOCALE_NAMESPACE';

import { emptyFunc } from '../../../helpers/function/emptyFunc';

import styles from './BuySubscriptionConfirmDialog.module.scss';
import { PAYMENT_STATUS } from '../../../const/payment/PAYMENT_STATUS';
import classNames from 'class-names';

const T_PREFIX = 'subscriptionsScreen.dialogs.buyConfirm';

const BuySubscriptionConfirmDialog = (props) => {
    const {
        isVisible,
        onClose,
        onConfirm,
    } = props;

    const { t } = useTranslation(LOCALE_NAMESPACE.COMMON);

    const { tintColor } = useSelector(COMPANIES_SELECTORS.companiesSelector);
    const { confirmText, paymentStatus, paymentLink } = useSelector(SUBSCRIPTIONS_SELECTOR.subscriptionsSelector);
    const { company } = useSelector(state => state.companies.selectedCompany) ?? {};

    const confirmButtonStyle = useMemo(() => ({
        background: tintColor,
    }), [tintColor]);

    const showLoader = useMemo(() =>
        paymentStatus === PAYMENT_STATUS.PENDING && !paymentLink,
    [paymentStatus, paymentLink])

    return (
        <Modal
            show={isVisible}
            container={document.getElementById('root_appybee_widget')}
            onHide={onClose}
        >
            <Modal.Header closeButton>
                <h4 className={styles.dialogTitle}>
                    {t(`${T_PREFIX}.header.title`)}
                </h4>
            </Modal.Header>

            <Modal.Body>
                {confirmText ? (
                    <>
                        <div
                            dangerouslySetInnerHTML={{ __html: confirmText }}
                            className={styles.contentContainer}
                        />
                        {company?.name && (
                            <div>
                                <span className={classNames(styles.label, 'mt-4 mb-2')}>
                                    {t('bookingConfirmScreen.companyName')}
                                </span>
                                <span data-testid='data-test-company-name' className={styles.description}>
                                    {company.name}
                                </span>
                            </div>
                        )}

                        {company?.coc_number && (
                            <div>
                                <span className={classNames(styles.label, 'mt-4 mb-2')}>
                                    {t('bookingConfirmScreen.cocNumber')}
                                </span>
                                <span data-testid='data-test-coc-number' className={styles.description}>
                                    {company.coc_number}
                                </span>
                            </div>
                        )}

                    </>
                ) : (
                    <div className='d-flex justify-content-center'>
                        <Loader
                            type="TailSpin"
                            color="#000"
                            height={48}
                            width={48}
                        />
                    </div>
                )}
            </Modal.Body>

            {confirmText && (
                <Modal.Footer className={styles.dialogFooter}>
                    <Button
                        style={confirmButtonStyle}
                        className={styles.confirmButton}
                        onClick={onConfirm}
                    >
                        {showLoader ? (
                            <Loader
                                type="TailSpin"
                                color="#000"
                                height={25}
                                width={25}
                            />
                        ) : t(`${T_PREFIX}.body.actions.confirm`)}
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    );
};

BuySubscriptionConfirmDialog.propTypes = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
};

BuySubscriptionConfirmDialog.defaultProps = {
    isVisible: false,
    onClose: emptyFunc,
    onConfirm: emptyFunc,
};

export default BuySubscriptionConfirmDialog;
